import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';

import Link from './Link';

const propTypes = {
    site: PropTypes.object.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {
};

class Menu extends Component {

    constructor(props) {
        super(props);

        this.renderItem = this.renderItem.bind(this);
        this.renderMenu = this.renderMenu.bind(this);

        this.state = {
            pathname: props.location.pathname,
        };
    }

    componentWillReceiveProps(nextProps) {
        const locationChanged = this.props.location.pathname !== nextProps.location.pathname;
        if (locationChanged) {
            this.setState({
                pathname: nextProps.location.pathname,
            });
        }
    }

    renderItem(item, index) {
        const key = `${item.handle}-${index}`;
        const className = classNames({
            active: this.state.pathname.indexOf(item.url) !== -1,
            'menu-item': true,
        });

        const iconClassName = classNames({
            icon: true,
            [item.icon]: true,
        });

        return (
            <li key={key} style={{ position: 'relative' }}>
                <Link to={item.url} className={className}>
                    <span className={iconClassName} />
                </Link>
                <div className="menu-item-label">
                    <span>{item.label}</span>
                    <span className="pin" />
                </div>
            </li>
        );
    }

    renderMenu(item, index) {
        const submenu = item.children.map(this.renderItem);

        const className = classNames({
            submenu: true,
            [item.color]: true,
            active: this.state.pathname.indexOf(item.url) !== -1,
        });

        return (
            <div key={`menu_section_${item.handle}_${index}`} className={className}>
                <ul>
                    {submenu}
                </ul>
                <Link to={item.url} className="label-section title">
                    {item.label}
                </Link>
                <div className="clearfix" />
            </div>
        );
    }

    render() {
        const { site } = this.props;
        const menu = site.menu.map(this.renderMenu);
        return (
            <header className="menu">
                <Link to="/" className="home" />
                <nav className="container">
                    {menu}
                    <div className="clearfix" />
                </nav>
            </header>
        );
    }
}

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

const MenuContainer = withRouter(connect(state => ({
    site: state.site,
    routing: state.routing,
}))(Menu));

export default MenuContainer;



// WEBPACK FOOTER //
// ./components/partials/Menu.jsx